import { configureStore } from "@reduxjs/toolkit";
import { reducer as searchBuilderReducer } from "#next/redux/searchBuilderSlice";
import { reducer as explorerReducer } from "#next/redux/explorerSlice";
import { reducer as catalogReducer } from "#next/redux/catalogSlice";
import { reducer as userSearchReducer } from "#next/redux/userSearchSlice";

export const reduxStore = configureStore({
  reducer: {
    searchBuilderReducer,
    explorerReducer,
    catalogReducer,
    userSearchReducer,
  },
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // Could be configured to be less sensitive, rather than disabled entirely
      serializableCheck: false,
    }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof reduxStore.getState>;
export type AppDispatch = typeof reduxStore.dispatch;
